/* Built In Imports */
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
/* External Imports */
import {
  Box,
  Container,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
} from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/* Services */
import { CheckIcon } from '@chakra-ui/icons';
import { nanoid } from 'nanoid';
import { getCurrentRegion } from 'services/commonService';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */
const PricingSectionInsightIndepth = ({ sectionContent }) => {
  const router = useRouter();
  const [currRegion, setCurrRegion] = useState('in');
  const [hideRegion, setHideRegion] = useState('in');

  useEffect(() => {
    (async () => {
      /* Logging the value of currRegion and currRegion?.country.toLowerCase() */
      let cRegion;
      try {
        cRegion = await getCurrentRegion();
        // console.log('cRegion', cRegion);
        setCurrRegion(router?.query?.region || cRegion?.country?.toLowerCase());
      } finally {
        if (cRegion?.length === 0) {
          setCurrRegion('us');
        }
      }
    })();
  }, []);
  useEffect(() => {
    if (currRegion) {
      if (currRegion === 'in') {
        setHideRegion('us');
      } else if (currRegion === 'us') {
        setHideRegion('in');
      }
    }
  }, [currRegion]);

  return (
    <Box
      fontFamily="var(--FedraSansStd-book)"
      mx="auto"
      w="100%"
      maxW={{ base: '100%', md: '100%', lg: '100%', xl: 1330, '2xl': '1330px' }}
    >
      <Box
        bg={`url(${config.imgPath}/d/103700/1691417871-what-to-expect-bg.png)`}
        position="relative"
        bgRepeat="no-repeat"
        paddingBottom={{ base: '0', lg: '70px' }}
        bgSize="cover"
        minH={{ base: '500px', lg: '400px' }}
      >
        <Box py={10}>
          <Heading
            color="#ffff"
            fontSize={{
              '2xl': '70px',
              xl: '70px',
              lg: '60px',
              md: '50px',
              base: '40px',
            }}
            lineHeight={{ md: '70px', base: '42px' }}
            paddingBottom={{ base: '0px', xl: '10px' }}
            fontFamily="var(--FedraSansCondensedMedium), sans-serif"
            as="h2"
            textAlign="center"
          >
            {sectionContent?.[0]?.text} &nbsp;
            {sectionContent?.[1]?.text}
          </Heading>
        </Box>
        <Box
          display="flex"
          alignItems="center"
          background="#fff"
          margin={{ base: '0px 20px 0px 20px', md: '0px auto' }}
          p={{ base: '10px', lg: '20px' }}
          maxW="954px"
        >
          <Container padding={{ md: '0px 30px', base: '5px 20px' }} maxW="100%">
            <TableContainer w="100%" whiteSpace="normal !important" maxW="100%">
              <Table
                variant={{ base: 'unstyled', md: 'simple' }}
                className="JsonTable"
              >
                <Tbody>
                  {sectionContent[6].table.data.map((col, i) => {
                    if (
                      col['New Column'].toLowerCase().slice(0, 2) !== hideRegion
                    ) {
                      return (
                        <Tr
                          key={nanoid()}
                          borderBottom={
                            i === sectionContent[6]?.table?.data?.length - 1
                              ? '0px solid '
                              : '1px solid rgba(0, 0, 0, 0.2)'
                          }
                          h="100%"
                        >
                          {sectionContent[6].table.columns.map((row, index) => {
                            if (index === 0) {
                              return (
                                <Td
                                  key={nanoid()}
                                  w={{ base: '100%', md: '30%' }}
                                  display={{
                                    base: 'inherit',
                                    md: 'table-cell',
                                  }}
                                  pl="9px"
                                  // w="100%"
                                  verticalAlign="baseline !important"
                                >
                                  <Box mt={{ base: '20px', md: '0' }}>
                                    <Text
                                      color="#686868"
                                      fontSize="18px"
                                      fontFamily="var(--FedraSansStd-book)"
                                      mb={{ base: '10px', md: '0' }}
                                      lineHeight={{ base: '30px', md: '40px' }}
                                    >
                                      {col[row]}
                                    </Text>
                                  </Box>
                                </Td>
                              );
                            } else if (index === 1) {
                              return (
                                <Td
                                  key={nanoid()}
                                  display={{
                                    base: 'inherit',
                                    md: 'table-cell',
                                  }}
                                  w={{ base: '100%', md: 'auto' }}
                                  // w="100%"
                                >
                                  <Box mb={{ base: '20px', md: '0' }}>
                                    <Text
                                      fontSize={{
                                        base: i === 0 ? '30px' : '16px',
                                        md: i === 0 ? '30px' : '18px',
                                      }}
                                      lineHeight={{
                                        base: i === 0 ? '30px' : '22px',
                                        md: '30px',
                                      }}
                                      fontFamily={
                                        i === 0
                                          ? 'var(--FedraSansCondensedMedium),sans-serif'
                                          : 'var(--FedraSansStd-medium), sans-serif'
                                      }
                                    >
                                      {col[row] === 'Y' ? (
                                        <CheckIcon
                                          color="#F58220"
                                          fontWeight="bold"
                                        />
                                      ) : (
                                        col[row]
                                      )}
                                      <Text
                                        as="span"
                                        color="#FF9900"
                                        fontFeatureSettings="'case' on"
                                        fontFamily="var(--FedraSansStd-medium), sans-serif"
                                        fontSize="18px"
                                        fontStyle="italic"
                                        fontWeight={500}
                                        lineHeight="31px"
                                      >
                                        &nbsp;
                                        {col[sectionContent[6].table.columns[3]]
                                          ? col[
                                              sectionContent[6].table.columns[3]
                                            ]
                                          : ''}
                                      </Text>
                                      <Text
                                        fontSize="16px"
                                        fontStyle="italic"
                                        fontWeight={500}
                                        color="#E00000"
                                      >
                                        {
                                          col[
                                            sectionContent[6].table.columns[4]
                                          ]
                                        }
                                      </Text>
                                    </Text>
                                  </Box>
                                </Td>
                              );
                            }
                          })}
                        </Tr>
                      );
                    }
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default PricingSectionInsightIndepth;
